import React, {useEffect, useState} from 'react'
import {useNavigate, useLocation} from 'react-router-dom'
import {ROUTES} from '../../../../_gori/constants'
import {VALID_PARTNER_HASHES} from '../core/_partners'
import {RegistrationForm} from './RegistrationForm'

export function RegistrationReferral() {
  const navigate = useNavigate()
  const location = useLocation()
  const [partnerName, setPartnerName] = useState<string>('')
  const [isValidPartner, setIsValidPartner] = useState(false)

  useEffect(() => {
    const hash = location.hash.substring(1)
    if (!hash || !VALID_PARTNER_HASHES.includes(hash)) {
      navigate(ROUTES.AUTH.LOGIN)
      return
    }
    try {
      const decoded = atob(hash)
      setPartnerName(decoded)
      setIsValidPartner(true)
    } catch (error) {
      navigate(ROUTES.AUTH.LOGIN)
    }
  }, [location.hash, navigate])

  if (!isValidPartner) {
    return null
  }

  return <RegistrationForm referrer={partnerName} />
}
